import React from "react";
import ExpenseHistoryDetails from "./ExpenseHistoryDetails";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import withHOC from "../../HOC/HOC";
import { DEFAULT_PAGINATION_RECORDS_COUNT } from "../CustomUIComponents/Pagination/PaginationConstants";
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import { Button, Col } from "react-bootstrap";
import { Strings } from "../../resources/i18n/i18n";
import { setSearchFilterAction } from "../../constants/Action";
import { OPERATION_STATUS } from "../../config/axios.init";
import {
  ANALYST_LOAN_DETAIL_FILTER,
  APPROVAL_DASHBOARD_FILTER,
  DAILY_STATUS_FILTER,
  FLR_SEARCH_FILTER,
  LOAN_DETAIL_FILTER,
  LOAN_PORTFOLIO_FILTER,
  MINIMART_LIST_FILTER,
  PERSON_DAILY_STATUS_FILTER,
  SEARCH_FILTER_PAGES,
  SLR_SEARCH_FILTER,
  SPED_L1_FILTER,
  SPED_L2_FILTER,
  WORKLOAD_MANAGEMENT_FILTER,
  DEFAULT_DURATION
} from "../../constants/appConstants";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import { setMinimartDetailsActiveTab } from "../MinimartDetails/MiniMartDetailsAction";
import { getCollectionExpenseHistoryAction, downloadCollectionExpenseHistoryAction } from "./ExpenseHistoryAction";
import fileDownload from "js-file-download";
import Utility from "../../utils/Utility";

class ExpenseHistoryContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFilter: {},
      showLoader: false,
      numberOfPages: DEFAULT_PAGINATION_RECORDS_COUNT,
      errorMessage: "",
      rows: [],
      isError: false,
      loanId: props.location.state?.loanId,
      expenseTypes: props.location.state?.expenseTypes || [],
    };
  }


componentWillUnmount() {
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.MINIMART_LIST &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.MINIMART_LIST,
        {
          ...MINIMART_LIST_FILTER,
        }
      );
    }

    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.APPROVAL_DASHBOARD &&
      !this.props.selectedFeature?.urls?.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.APPROVAL_DASHBOARD,
        {
          ...APPROVAL_DASHBOARD_FILTER,
        }
      );
    }
    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.WORKLOAD_MANAGEMENT &&
      !this.props.selectedFeature?.urls?.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.WORKLOAD_MANAGEMENT,
        { ...WORKLOAD_MANAGEMENT_FILTER }
      );
    }
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.LOAN_DETAIL &&
      !this.props.selectedFeature?.urls?.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setMinimartDetailsActiveTab(null);
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.LOAN_DETAIL,
        { ...LOAN_DETAIL_FILTER }
      );
    }
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.MINIMART_LIST &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.MINIMART_LIST,
        {
          ...MINIMART_LIST_FILTER,
        }
      );
    }
    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.APPROVAL_DASHBOARD &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.APPROVAL_DASHBOARD,
        {
          ...APPROVAL_DASHBOARD_FILTER,
        }
      );
    }

    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.SPED_L2 &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(SEARCH_FILTER_PAGES.SPED_L1, {
        ...SPED_L1_FILTER,
      });
      this.props.setSearchFilterAction(SEARCH_FILTER_PAGES.SPED_L2, {
        ...SPED_L2_FILTER,
      });
    }
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.LOAN_PORTFOLIO &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.LOAN_PORTFOLIO,
        { ...LOAN_PORTFOLIO_FILTER }
      );
    }

    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.SECOND_LEVEL_REPORT &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.FIRST_LEVEL_REPORT,
        { ...FLR_SEARCH_FILTER }
      );
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.SECOND_LEVEL_REPORT,
        { ...SLR_SEARCH_FILTER

         }
      );
    }
    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.PERSON_DAILY_STATUS &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.DAILY_STATUS,
        { ...DAILY_STATUS_FILTER }
      );
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.PERSON_DAILY_STATUS,
        { ...PERSON_DAILY_STATUS_FILTER }
      );
    }

    // loan approval
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.LOAN_DETAIL &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setMinimartDetailsActiveTab(null);
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.LOAN_DETAIL,
        { ...LOAN_DETAIL_FILTER }
      );
    }
    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.WORKLOAD_MANAGEMENT &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.WORKLOAD_MANAGEMENT,
        { ...WORKLOAD_MANAGEMENT_FILTER }
      );
    }
    if (
      this.props.searchPage ===
      SEARCH_FILTER_PAGES.ANALYST_LOAN_DETAIL &&
      !this.props.selectedFeature?.urls.includes(
        this.props.history.location.pathname
      )
    ) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.ANALYST_LOAN_DETAIL,
        { ...ANALYST_LOAN_DETAIL_FILTER }
      );
    }
    if (!this.isCardClick) {
      this.props.setMinimartDetailsActiveTab(null);
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.LOAN_DETAIL,
        { ...LOAN_DETAIL_FILTER },
        SEARCH_FILTER_PAGES.LOAN_DETAIL
      );
    }
  }

  handleExpenseSearchFilter = (searchFilterObject) => {
    this.setState({
      searchFilter: {
        fromDate: searchFilterObject.searchCriteria.fromDate,
        toDate: searchFilterObject.searchCriteria.toDate,
        configType: searchFilterObject.searchCriteria.configType,
        status: searchFilterObject.searchCriteria.status,
        offset: searchFilterObject.offset,
        limit: searchFilterObject.limit,
      },
      showLoader: true,
    });

    const filters = {
      startDate: Utility.convertDateIntoMiliSeconds(searchFilterObject.searchCriteria.fromDate),
      endDate: Utility.convertDateIntoMiliSeconds(searchFilterObject.searchCriteria.toDate),
      limit: searchFilterObject.limit,
      offset: searchFilterObject.offset,
    };

    if (searchFilterObject.searchCriteria.configType) {
      filters.configType =
        searchFilterObject.searchCriteria.configType;
    }

    if (searchFilterObject.searchCriteria.status) {
      filters.status = searchFilterObject.searchCriteria.status;
    }

    getCollectionExpenseHistoryAction(
      this.state.loanId,
      filters,
      (apiResponse) => {
        this.setState({ showLoader: false });
        if (apiResponse.status === OPERATION_STATUS.SUCCESS) {
          this.setState({
            rows: apiResponse.data?.data || [],
            numberOfPages: 1,
          });
        } else {
          this.setState({
            isError: true,
            errorMessage: apiResponse.error?.message || "ErrorLoadingData",
          });
        }
      }
    );
  };

  handleDownload = (fileType) => {
    this.setState({ showLoader: true, isError: false });
    const filters = {
      startDate: Utility.convertDateIntoMiliSeconds(this.state.searchFilter.fromDate || DEFAULT_DURATION.fromDate) ,
      endDate: Utility.convertDateIntoMiliSeconds(this.state.searchFilter.toDate || DEFAULT_DURATION.toDate) ,
    };

    if (this.state.searchFilter.configType) {
      filters.configType =
        this.state.searchFilter.configType;
    }

    if (this.state.searchFilter.status) {
      filters.status = this.state.searchFilter.status;
    }
    downloadCollectionExpenseHistoryAction(
      this.state.loanId,
      fileType,
      filters,
      (response) => {
        if (response.status === OPERATION_STATUS.SUCCESS) {
          if (Utility.checkBlobTypeForFileDownload(response.data.type)) {
            fileDownload(
              response.data,
              Strings("ExpenseHistory") +
                "-" +
                Utility.getReportFormattedDateString(
                  Utility.convertDateIntoMiliSeconds(new Date())
                ) +
                Utility.getFileType(fileType)
            );
            this.setState({ showLoader: false });
          } else {
            this.setState({
              showLoader: false,
              isError: true,
              errorMessage: Strings("NoRecordsFound"),
            });
          }
        } else {
          this.setState({
            showLoader: false,
            isError: true,
            errorMessage: response.error.message,
          });
        }
      }
    );
  };

  handleBackButtonClick = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <div>
        <LoadingModal showLoadingModal={this.state.showLoader} />
        {this.state.isError && (
          <UserNotification
            key='Error'
            userNotificationObj={{
              message: Strings(this.state.errorMessage),
              level: "error",
            }}
          />
        )}
        {!this.state.isError && this.state.searchFilter && (
          <>
            <ExpenseHistoryDetails
              searchFilter={this.state.searchFilter}
              handleExpenseSearchFilter={this.handleExpenseSearchFilter}
              handleDownload={this.handleDownload}
              rows={this.state.rows}
              numberOfPages={this.state.numberOfPages}
              expenseTypes={this.state.expenseTypes}
            />
            <Col md={1} className='alignCenter ps-0 pt-2'>
              <Button
                className='buttonBorder'
                onClick={this.handleBackButtonClick}
              >
                {Strings("Back").toUpperCase()}
              </Button>
            </Col>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  searchFilter: state.searchFilterReducer.notesSearchFilter,
  searchPage: state.searchFilterReducer.searchPage,
  selectedFeature: state.sidebarReducer.selectedFeature,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { setSearchFilterAction, setMinimartDetailsActiveTab },
    dispatch
  );
};

const ExpenseHistoryWrapper = withHOC(ExpenseHistoryContainer);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpenseHistoryWrapper);
